import React, {useEffect, useState} from 'react'
import Moment from 'react-moment'
import * as ReactBootstrap from 'react-bootstrap'
import {BooleanConverter, Loading} from '../../../components'
import {GSXService} from '../../../services'
import {showErrorToast} from '../../../state/toasts'
import {useDispatch} from 'react-redux'

export type DeviceWarrantyProps={
  device_identifier:string
  onDeviceInfo?:(warranty:any)=>void
}
export const DeviceWarranty = ({ device_identifier, onDeviceInfo }:DeviceWarrantyProps) => {
  const dispatch = useDispatch()
  const [deviceInfo, setDeviceInfo] = useState()

  useEffect(() => {
    const getDeviceInfo = () => {
      const data = { identifier: device_identifier }
      new GSXService()
        .warranty(data)
        .then((response) => {
          setDeviceInfo(response.device)
          if (onDeviceInfo) onDeviceInfo(response?.device)
        })
        .catch((errors) => {
          dispatch(
            showErrorToast('Could not get warranty Info ', errors.response?.data)
          )
        })
    }
    getDeviceInfo()
  }, [device_identifier, dispatch, onDeviceInfo])
  if (!deviceInfo) return <Loading />
  const {
    identifiers,
      ctoConfiguration,
    configDescription,
    warrantyInfo,
      soldToName,
      productLine,
      loanerStatus,
    configCode,
    productImageURL,
  } = deviceInfo
  const {meid, imei, serial} = identifiers;
  return (
      <ReactBootstrap.Table>
        <tbody>

          <tr>
            <th>Serial</th>
            <td>{serial}</td>
          </tr>
          {imei && (
            <>
              <tr>
                <th>IMEI</th>
                <td>{imei}</td>
              </tr>{' '}
            </>
          )}
          {meid && (
            <>
              <tr>
                <th>MEID</th>
                <td>{meid}</td>
              </tr>
            </>
          )}
          <tr>
            <th>Config Description</th>
            <td>
              {configDescription}-<strong>{configCode}</strong>
              <span className={"ps-5"}>
                <img src={productImageURL} height={"32px"} width={"32px"}   alt={"product modal"}/>{' '}
              </span>
            </td>
          </tr>
          <tr>
            <th>Warranty Status</th>
            <td>
              {warrantyInfo.warrantyStatusCode} -
              {warrantyInfo.warrantyStatusDescription}
            </td>
          </tr>
          <tr>
            <th>Days Remaining</th>
            <td>{warrantyInfo.daysRemaining}</td>
          </tr>
          <tr>
            <th>Purchase Country</th>
            <td>{warrantyInfo.purchaseCountryDesc}</td>
          </tr>
          <tr>
            <th>Purchase Date</th>
            <td>
              <Moment format="DD-MM-YYYY">{warrantyInfo.purchaseDate}</Moment>{' '}
              <strong>
                (
                <small>
                  <Moment fromNow>{warrantyInfo.purchaseDate}</Moment>
                </small>
                )
              </strong>
            </td>
          </tr>
          <tr>
            <th>Onsite Coverage</th>
            <td>
              {BooleanConverter(warrantyInfo.onsiteCoverage, 'text-left')}
            </td>
          </tr>
          <tr>
            <th>Labor Covered</th>
            <td>{BooleanConverter(warrantyInfo.laborCovered, 'text-left')}</td>
          </tr>
          <tr>
            <th>Limited Warranty</th>
            <td>
              {BooleanConverter(warrantyInfo.limitedWarranty, 'text-left')}
            </td>
          </tr>
          <tr>
            <th>Part Covered</th>
            <td>{BooleanConverter(warrantyInfo.partCovered, 'text-left')}</td>
          </tr>
          <tr>
            <th>Personalized</th>
            <td>{BooleanConverter(warrantyInfo.personalized, 'text-left')}</td>
          </tr>
         <tr>
            <th>CTO Configuration</th>
            <td>{ctoConfiguration}</td>
          </tr>
          <tr>
            <th>Sold To Name</th>
            <td>{soldToName}</td>
          </tr>
          <tr>
            <th>Product Line</th>
            <td>{productLine}</td>
          </tr>
          <tr>
            <th>Loaner</th>
               <td>{loanerStatus}</td>
          </tr>
        </tbody>
      </ReactBootstrap.Table>

  )
}
